export const COOKIES_KEYS = {
	LanguageAdded: 'LanguageAdded',
};
